module.exports = __webpack_public_path__ + "img/import-status.af20cf7e.svg";